export const CaseStatus = {
	created: 10,
	printed: 20,
	packed: 30,
	dispatch: 40,
	invoicing: 50,
	invoiced:  60,
	rejected:  70,
 	not_authorized: 80
}
